<div class="modal-header mfp-header">
    <h5 class="modal-title">{{ Message.MessageID ? 'Edit' : 'Create' }} Message</h5>
    <button
            type="button"
            class="btn-close"
            aria-label="Close"
            (click)="Cancel()"
    ></button>
</div>
<div class="modal-body">
    <div class="container-fluid">
        <div class="row my-2">
            <div class="col-12 col-md-6">Caller Name:</div>
            <div class="col-12 col-md-6">
                <input type="text" class="form-control" [(ngModel)]="Message.CallerName" />
            </div>
        </div>
        <div class="row my-2">
            <div class="col-12 col-md-6">Caller Company:</div>
            <div class="col-12 col-md-6">
                <input type="text" class="form-control" [(ngModel)]="Message.CallerCompany" />
            </div>
        </div>
        <div class="row my-2">
            <div class="col-12 col-md-6">Caller Phone Number:</div>
            <div class="col-12 col-md-6">
                <input type="text" class="form-control" [(ngModel)]="Message.CallerPhoneNumber" />
            </div>
        </div>
        <div class="row my-2">
            <div class="col-12 col-md-6">Recipient:</div>
            <div class="col-12 col-md-6">
                <input type="text" class="form-control" [ngModel]="FormatEmployee(Message.RecipientEmployee)" disabled />
            </div>
        </div>
        <div class="row my-2">
            <div class="col-12 col-md-6">Intended For:</div>
            <div class="col-12 col-md-6">
                <input type="text" class="form-control"
                       [(ngModel)]="Message.IntendedForEmployee"
                       [ngbTypeahead]="EmployeeSearch"
                       [inputFormatter]="FormatEmployee"
                       [resultFormatter]="FormatEmployee"
                       [editable]="false"
                />
            </div>
        </div>
        <div class="row my-2">
            <div class="col-12 col-md-6">Received Date:</div>
            <div class="col-12 col-md-6">
                <input type="datetime-local"
                       class="form-control"
                       [ngModel]="Message.CallReceivedDate | date:'yyyy-MM-ddTHH:mm:ss'"
                       (ngModelChange)="Message.CallReceivedDate = $event" />
            </div>
        </div>
        <div class="row my-2">
            <div class="col-12 col-md-6">Options:</div>
            <div class="col-12 col-md-6">
                <label>
                    <input type="checkbox" [(ngModel)]="Message.IsAddressed" />
                    Addressed
                </label>
                <br />
                <label>
                    <input type="checkbox" [(ngModel)]="Message.IsUrgent" />
                    Urgent
                </label>
                <br />
                <label>
                    <input type="checkbox" [(ngModel)]="Message.Telephoned" />
                    Telephoned
                </label>
                <br />
                <label>
                    <input type="checkbox" [(ngModel)]="Message.CalledToSeeYou" />
                    Called To See You
                </label>
                <br />
                <label>
                    <input type="checkbox" [(ngModel)]="Message.WantsToSeeYou" />
                    Wants To See You
                </label>
                <br />
                <label>
                    <input type="checkbox" [(ngModel)]="Message.ReturnedYourCall" />
                    Returned Your Call
                </label>
                <br />
                <label>
                    <input type="checkbox" [(ngModel)]="Message.PleaseCall" />
                    Please Call
                </label>
                <br />
                <label>
                    <input type="checkbox" [(ngModel)]="Message.WillCallAgain" />
                    Will Call Again
                </label>
            </div>
        </div>
        <div class="row my-2">
            <div class="col-12 col-md-6">Message:</div>
            <div class="col-12 col-md-6">
                <textarea class="form-control" [(ngModel)]="Message.MessageText"></textarea>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="Cancel()">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="Save()">Save</button>
</div>